import _implicitStylesheets from "./securityReviewProgressIndicator.css";
import _implicitScopedStylesheets from "./securityReviewProgressIndicator.scoped.css?scoped=true";
import _c360Icon from "c360/icon";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="card-footer slds-p-left_medium slds-p-right_medium${0}"${2}><div${"c1"}${2}>${"t2"}</div><div class="description slds-m-top_xx-small slds-m-bottom_medium${0}"${2}>${"t4"}</div><div class="estimated-text slds-m-top_xx-small slds-m-bottom_medium${0}"${2}>${"t6"}</div></div>`;
const stc0 = {
  classMap: {
    "slds-grid": true
  },
  key: 0
};
const stc1 = {
  "slds-size_1-of-4": true
};
const stc2 = {
  "main-icon": true
};
const stc3 = {
  "sub-icon": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {k: api_key, ncls: api_normalize_class_name, c: api_custom_element, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, i: api_iterator} = $api;
  return [api_element("div", stc0, api_iterator($cmp.processedSteps, function (item) {
    return api_element("div", {
      classMap: stc1,
      key: api_key(1, item.title)
    }, [api_element("div", {
      className: api_normalize_class_name(item.cardClass),
      key: 2
    }, [api_element("div", {
      className: api_normalize_class_name(item.imageClass),
      key: 3
    }, [api_custom_element("c360-icon", _c360Icon, {
      classMap: stc2,
      props: {
        "iconName": item.mainIcon,
        "iconClass": "default",
        "size": "medium"
      },
      key: 4
    }), item.subIcon ? api_element("div", {
      className: api_normalize_class_name(item.subIconClass),
      key: 5
    }, [api_custom_element("c360-icon", _c360Icon, {
      classMap: stc3,
      props: {
        "iconName": item.subIcon,
        "iconClass": "neutral",
        "size": "x-small"
      },
      key: 6
    })]) : null]), api_static_fragment($fragment1, 8, [api_static_part(1, {
      className: api_normalize_class_name(item.titleClass)
    }, null), api_static_part(2, null, api_dynamic_text(item.title)), api_static_part(4, null, api_dynamic_text(item.description)), api_static_part(6, null, api_dynamic_text(item.estimatedText))])])]);
  }))];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-7fiq8abo8ll";
tmpl.legacyStylesheetToken = "appx-securityReviewProgressIndicator_securityReviewProgressIndicator";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
